import React from 'react';

const profileImageStyle = {
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: 'black',
};

const ProfileImage = ({ margin, width, height, src }) => (
    <div style={{
        width,
        margin,
    }} >
        <img
            alt='Profile'
            src={src || '/images/ic_person_48px.svg'}
            style={{ height: height ? height : width, width, ...profileImageStyle }}
        />
    </div>
);

export default {
    Small: props => (<ProfileImage width={48} {...props} />),
    Large: props => (<ProfileImage width={96} {...props} />),
};
